import React from 'react'

import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import ForgedSteelFittingsDetails from '../Components/ForgedSteelFittingsDetails'

const ForgedSteelsFittings = () => {
  return (
    <div>
      <Navbar />
      <ForgedSteelFittingsDetails />
      <Footer />
    </div>
  )
}

export default ForgedSteelsFittings